const url = window.location

export default {
  webRoot: `${url.protocol}//${url.host}`,
  recruitmentWebRoot: import.meta.env.VITE_ENDPOINT_RECRUIT_WEB_ROOT,
  endpoints: {
    auth: import.meta.env.VITE_ENDPOINT_AUTH,
    graphql: import.meta.env.VITE_ENDPOINT_GRAPHQL,
    graphqlws: import.meta.env.VITE_ENDPOINT_GRAPHQLWS,
    legacyAPI: import.meta.env.VITE_ENDPOINT_LEGACY_API,
  },
}
